import { PaymentMethodType } from "./payment-method-type";

export class PaymentMethod {
    public customerKey: number;
    public paymentMethodType: PaymentMethodType;
    public paymentMethodKey: number | null;
	public isPrimaryPaymentMethod: boolean;
	public isThirdParty: boolean;
    public accountName: string;
    public accountNumber: string;
	public city: string;
	public state: string;
    public zipCode: string;
    public paymentAccountNickname: string;
 
	constructor() {
		this.customerKey = -1;
        this.paymentMethodType = PaymentMethodType.NotSet;
        this.paymentMethodKey = null;
        this.isPrimaryPaymentMethod = false;
        this.accountName = '';
        this.accountNumber = '';
        this.zipCode = '';
		this.paymentAccountNickname = '';
	}

	deserialize(input: any): PaymentMethod {
		var self: any = this;
		for (let prop in input) {
			self[prop] = input[prop];
		}
		return self;
	}
}

export class Ach extends PaymentMethod {
	public aba: string;
	public achAccountType: AchAccountType
}

export class Card extends PaymentMethod {
	public expirationMonth: number;
	public expirationYear: number;
	public cvv: string;
	public cardNetworkName: string;
}

export enum AchAccountType {
	checking = 1,
	savings = 2,
	businessChecking = 3
}
